import { useCallback } from 'react';

import { UpsellContext, UpsellOffer } from '@/entities/pricing';

import { useInterfaceLanguage } from '@/shared/i18n';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { usePlanChangeConfirmation } from '../usePlanChangeConfirmation';

const stayOnPage = () => undefined;

export const useUpsellCheckout = () => {
  const { t } = useInterfaceLanguage();
  const openPlanChangeConfirmation = usePlanChangeConfirmation({ onClosedAfterProcessing: stayOnPage });

  return useCallback(
    (context: UpsellContext, offer: UpsellOffer, surface: string) => {
      const analytics = {
        currentPlan: context.currentPlan.name,
        newPlan: offer.plan.name,
        offer: offer.kind,
        source: 'upsell',
        surface,
      };

      openPlanChangeConfirmation({
        confirmButtonText: t('pricing.change.upgradeNow'),
        errorMessage: t('pricing.change.upgradeError'),
        planId: offer.plan.id,
        priceId: offer.price.id,
        successDescriptions: {
          noPayment: t('pricing.change.upgradeSuccess'),
          paid: t('pricing.change.upgradePaidSuccess'),
        },
        onConfirmAnalytics: () => MixpanelEvents.upgradeSubscribeConfirmClick(analytics),
      });
    },
    [openPlanChangeConfirmation, t],
  );
};
